 <template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>权限设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="23">  <el-table :data="quanxianList"    style="width: 100%"   >
        <el-table-column type="index"  label="序号" > </el-table-column>
        <el-table-column prop="menu_name" label="名称"></el-table-column>
        <el-table-column prop="menu_path_p" label="主路径" ></el-table-column>
        <el-table-column prop="menu_path_c" label="子路径"></el-table-column>
      </el-table>
        </el-col>
      </el-row>
    
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      quanxianList: []
    };
  },
  created() {
    this.getQuanxianList();
  },
  methods: {
    async getQuanxianList() {
      const { data: rec } = await this.$http.get('get_api', {
        // 调用普通api get接口 1
        params: { C_type: 'quanxian_list' }
      });
      console.log(JSON.parse(rec.data)[0])
     if (JSON.parse(rec.data)[0].status === 200) this.quanxianList = JSON.parse(rec.data)[0].dataList;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
